import { Link } from "react-router-dom";

const COLS = [
  {
    label: "Astrarium",
    items: [
      { to: "/", text: "Home" },
      { to: "/about", text: "About the almanac" },
      { to: "/how-it-works", text: "How it works" },
    ],
  },
  {
    label: "Explore",
    items: [
      { to: "/zodiac", text: "The 12 signs" },
      { to: "/learn", text: "Learn library" },
      { to: "/faq", text: "FAQ" },
    ],
  },
  {
    label: "Legal",
    items: [
      { to: "/legal", text: "Privacy" },
      { to: "/terms", text: "Terms of use" },
      { to: "/contact", text: "Contact" },
    ],
  },
];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative z-10 mt-12 sm:mt-16 px-4 sm:px-6 py-12 border-t border-white/[0.06]"
  >
    <div className="max-w-5xl mx-auto">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 sm:gap-12 mb-12">
        <div className="col-span-2 sm:col-span-1">
          <p className="font-display text-xl text-[#F5EBD8] mb-2">
            Astrarium<span className="text-stardust">.</span>
          </p>
          <p className="text-slate-500 text-xs leading-relaxed max-w-xs">
            An astral almanac. Readings written with the help of AI, grounded in
            traditional astrology. For curiosity, not prescription.
          </p>
        </div>
        {COLS.map((col) => (
          <nav key={col.label} className="text-xs">
            <p className="text-stardust/80 uppercase tracking-[0.25em] text-[10px] mb-4">{col.label}</p>
            <ul className="space-y-3">
              {col.items.map((item) => (
                <li key={item.text}>
                  {item.to ? (
                    <Link
                      to={item.to}
                      data-testid={`footer-link-${item.text.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-slate-300 hover:text-stardust transition-colors"
                    >
                      {item.text}
                    </Link>
                  ) : (
                    <a
                      href={item.href}
                      data-testid={`footer-link-${item.text.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-slate-300 hover:text-stardust transition-colors break-all"
                    >
                      {item.text}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-white/[0.04]">
        <p className="text-[10px] text-slate-600 tracking-[0.2em] uppercase">
          © {new Date().getFullYear()} Astrarium · Made under a kind sky
        </p>
        <p className="text-[10px] text-slate-600 tracking-[0.15em] uppercase">
          For reflection, not prescription
        </p>
      </div>
    </div>
  </footer>
);
